import React, { useEffect } from "react";
import "./RetailCopilotPage.css";
import { AldiMark, COPILOT_TOKEN, useKodlyLoader } from "./retailDemo";

// Store copilot of the retail demo: the team's chat, booted docked like the operators-ui
// does for Radio Popular's staff, inside a store portal. The store, its address and hours
// are real (aldi.pt); stock and procedures are simulated, and the footer says so.
const CONTAINER_ID = "retail-copilot-chat";

const STORE = {
  name: "ALDI Viseu Repeses",
  address: "Avenida Luís Martins, EN 2, 3500-179 Viseu",
  hours: "Todos os dias, das 08:00 às 21:00",
  // The stock tool's distances from this address (4.71 and 14.68 km), so the panel says
  // what the copilot says. Store to store, Mangualde is 14,6.
  nearby: ["ALDI Viseu, São João da Carreira (4,7 km)", "ALDI Mangualde (14,7 km)"],
};

const ASK_ME = [
  "O que muda hoje na loja?",
  "Esgotou aqui. Em que loja perto ainda há?",
  "Qual detergente sai mais barato por lavagem?",
  "Que Oportunidades começam amanhã?",
  "Como faço uma devolução sem talão?",
  "Faz-me um teste sobre a abertura da loja",
];

function today() {
  return new Intl.DateTimeFormat("pt-PT", { weekday: "long", day: "numeric", month: "long" }).format(new Date());
}

function RetailCopilotPage() {
  useEffect(() => {
    document.title = "Portal da Loja · ALDI Viseu Repeses";
  }, []);
  useKodlyLoader(COPILOT_TOKEN, { mode: "docked", container: CONTAINER_ID });

  return (
    <div className="rcp-page">
      <header className="rcp-header">
        <div className="rcp-brand">
          <AldiMark className="rcp-mark" />
          <div>
            <div className="rcp-title">Portal da Loja</div>
            <div className="rcp-subtitle">{STORE.name}</div>
          </div>
        </div>
        <div className="rcp-meta">
          <span className="rcp-date">{today()}</span>
          <span className="rcp-demo">Demo</span>
        </div>
      </header>
      <main className="rcp-main">
        <aside className="rcp-rail">
          <section className="rcp-card">
            <h2>A tua loja</h2>
            <p className="rcp-strong">{STORE.name}</p>
            <p>{STORE.address}</p>
            <p>{STORE.hours}</p>
          </section>
          <section className="rcp-card">
            <h2>Lojas mais perto</h2>
            <ul>
              {STORE.nearby.map((store) => (
                <li key={store}>{store}</li>
              ))}
            </ul>
          </section>
          <section className="rcp-card rcp-card--accent">
            <h2>Pergunta ao Copiloto</h2>
            <ul>
              {ASK_ME.map((question) => (
                <li key={question}>{question}</li>
              ))}
            </ul>
            <p className="rcp-hint">Por escrito ou por mensagem de voz, em português ou noutra língua.</p>
          </section>
        </aside>
        <div id={CONTAINER_ID} className="rcp-chat" />
      </main>
      <footer className="rcp-footer">
        Demonstração Kodly. Produtos, preços, Oportunidades e lojas de aldi.pt; stock e procedimentos internos simulados.
      </footer>
    </div>
  );
}

export default RetailCopilotPage;
